var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15510_27804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 2.05811V0.724772C12.6666 0.547961 12.5963 0.378392 12.4713 0.253368C12.3463 0.128343 12.1767 0.0581055 11.9999 0.0581055C11.8231 0.0581055 11.6535 0.128343 11.5285 0.253368C11.4035 0.378392 11.3333 0.547961 11.3333 0.724772V2.05811H12.6666Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 2.05811V0.724772C4.66659 0.547961 4.59635 0.378392 4.47132 0.253368C4.3463 0.128343 4.17673 0.0581055 3.99992 0.0581055C3.82311 0.0581055 3.65354 0.128343 3.52851 0.253368C3.40349 0.378392 3.33325 0.547961 3.33325 0.724772V2.05811H4.66659Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.3915H2C1.46957 15.3915 0.960859 15.1808 0.585786 14.8057C0.210714 14.4307 0 13.922 0 13.3915L0 4.72485C0 4.19442 0.210714 3.68571 0.585786 3.31064C0.960859 2.93557 1.46957 2.72485 2 2.72485H14C14.5304 2.72485 15.0391 2.93557 15.4142 3.31064C15.7893 3.68571 16 4.19442 16 4.72485V13.3915C16 13.922 15.7893 14.4307 15.4142 14.8057C15.0391 15.1808 14.5304 15.3915 14 15.3915ZM14.6667 6.05819H1.33333V13.3915C1.33333 13.5683 1.40357 13.7379 1.5286 13.8629C1.65362 13.9879 1.82319 14.0582 2 14.0582H14C14.1768 14.0582 14.3464 13.9879 14.4714 13.8629C14.5964 13.7379 14.6667 13.5683 14.6667 13.3915V6.05819Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 7.39136H2.66675V9.39136H5.33341V7.39136Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 7.39136H6.66675V9.39136H9.33341V7.39136Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 10.7249H2.66675V12.7249H5.33341V10.7249Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 10.7249H6.66675V12.7249H9.33341V10.7249Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 7.39136H10.6667V9.39136H13.3334V7.39136Z",
    fill: "#795AF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15510_27804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0581055)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.88d10493d0d3aee24fe88eb93ee18107.svg";
export { ForwardRef as ReactComponent };